import React, { useState } from 'react';
import DataLoading from '../../../js/DataLoading';
import SGMSClient from '../../../js/SGMSClient';
import { store } from '../../../stores/store';
import './PublicMeetingsButtons.css';



const PublicMeetingsButtons = () => {
  const [errorMessage, setErrorMessage] = useState(false);

  function launchmeeting(meeting) {
    SGMSClient.meetingGetWithCode(meeting.code, SGMSClient.currentUser.UserLogin)
    .then(meeting => SGMSClient.meetingConnect(meeting))
    .then(() => store.secondLoad(SGMSClient.currentMeeting.Config, meeting))
    .catch(msg => {
      setErrorMessage(msg)
    })

  }


  return (
    <div className="PublicMeetingsButtons">
      {DataLoading.public_meetings
      .filter(m => m.id !== null)
      .map(meeting =>
      <div key={meeting.id}>
        <button onClick={() => launchmeeting(meeting) }>{store.t(meeting.id)}</button>
      </div>
      )}

      {errorMessage && <p className="error">{store.t("error_connect_multiplayer_game")}</p>}

    </div>
  );
};

export default PublicMeetingsButtons;
